import { useState } from 'react';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export default function PWAInstallBanner() {
  const { canInstall, install } = usePWAInstall();
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('pwa-banner-dismissed') === 'true';
  });

  if (!canInstall || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('pwa-banner-dismissed', 'true');
  };

  const handleInstall = async () => {
    const accepted = await install();
    if (accepted) {
      setDismissed(true);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 safe-bottom">
      <div className="mx-auto max-w-lg p-4">
        <div className="flex items-center gap-3 rounded-2xl bg-indigo-600 p-4 shadow-lg shadow-indigo-600/25">
          {/* 아이콘 */}
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </div>

          {/* 텍스트 */}
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-white">앱으로 설치하기</p>
            <p className="text-xs text-indigo-200">홈 화면에 추가하면 더 빠르게 이용할 수 있어요</p>
          </div>

          {/* 버튼 */}
          <div className="flex shrink-0 items-center gap-2">
            <button
              onClick={handleDismiss}
              className="rounded-lg px-2 py-1.5 text-xs text-indigo-200 hover:text-white"
            >
              닫기
            </button>
            <button
              onClick={handleInstall}
              className="rounded-lg bg-white px-3 py-1.5 text-xs font-semibold text-indigo-600 hover:bg-indigo-50"
            >
              설치
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
